'use client';

import Icon from '@/components/ui/AppIcon';

interface FilterBarProps {
    categories: string[];
    activeCategory: string;
    onCategoryChange: (category: string) => void;
    searchQuery: string;
    onSearchChange: (query: string) => void;
}

export default function FilterBar({
    categories,
    activeCategory,
    onCategoryChange,
    searchQuery,
    onSearchChange,
}: FilterBarProps) {
    return (
        <div className="bg-surface border border-border rounded-xl p-6 mb-8">
            <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between">
                <div className="flex flex-wrap gap-2">
                    {categories.map((category) => (
                        <button
                            key={category}
                            onClick={() => onCategoryChange(category)}
                            className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 ${activeCategory === category
                                    ? 'bg-brand-primary text-brand-primary-foreground shadow-md'
                                    : 'bg-white text-text-secondary hover:bg-muted hover:text-text-primary'
                                }`}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                <div className="relative w-full lg:w-80">
                    <Icon
                        name="MagnifyingGlassIcon"
                        size={20}
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary"
                    />
                    <input
                        type="text"
                        placeholder="Search projects..."
                        value={searchQuery}
                        onChange={(e) => onSearchChange(e.target.value)}
                        className="w-full pl-10 pr-4 py-2.5 bg-white border border-border rounded-lg text-sm text-text-primary placeholder:text-text-secondary focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all duration-200"
                    />
                </div>
            </div>
        </div>
    );
}